import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { TranscriptContext } from '../../contexts/TranscriptContext';
import { memo, useContext, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { formatTranscriptForClipboard } from '../../utils/copyTranscriptUtils';
import { ClipboardIcon } from 'foundations-assets/icons/components/ClipboardIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CopyTranscriptButton({
  onCopyTranscriptClick
}) {
  const {
    transcriptUtterances,
    transcriptParticipants
  } = useContext(TranscriptContext);
  const transcriptForClipboard = useMemo(() => {
    return formatTranscriptForClipboard(transcriptUtterances, transcriptParticipants);
  }, [transcriptParticipants, transcriptUtterances]);
  return /*#__PURE__*/_jsxs(CopyButton, {
    size: "small",
    use: "tertiary",
    hint: '',
    value: transcriptForClipboard,
    onClick: onCopyTranscriptClick,
    children: [/*#__PURE__*/_jsx(ClipboardIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.transcript.copyTranscriptButton"
    })]
  });
}
export default /*#__PURE__*/memo(CopyTranscriptButton);